// extracted by mini-css-extract-plugin
export default {"fileList":"PdfUpload_fileList__CQoZn","file":"PdfUpload_file__wO8Rb","title":"PdfUpload_title__we-v3"};